import { Simulation } from './components/simulation';
import { Scenarios } from './components/scenarios';
import { Header } from './components/header';
import { SCENARIOS } from './mocks';
import { useSearchParams } from 'react-router';
import { ScenarioNotFound } from './components/not-found';

export default function DemoPage() {
  const [searchParams] = useSearchParams();

  const scenarioId = searchParams.get('scenarioId');
  const scenario = SCENARIOS.find(scenario => scenario.id === scenarioId);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Hero Section */}
      <Header isOpenSimulation={!!scenarioId} />

      {/* Simulation Preview */}
      {!scenarioId ? (
        <Scenarios scenarios={SCENARIOS} />
      ) : scenario ? (
        <Simulation scenario={scenario} />
      ) : (
        <ScenarioNotFound />
      )}
    </div>
  );
}
